import { Component, OnInit, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommunityService } from '../../_services/community.service';
import { VaService } from '../../_services/va.service'
import { TourService } from 'ngx-tour-ng-bootstrap';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
   host: {
    '(document:click)': 'onClick($event)',
  },
})
export class SidebarComponent implements OnInit {



  showSubMenu =false;
  showMenu = false;
  badge = true;



  steps = [
    { 
     tourAnchor: 'kb-menu',
     label: "createknowledge",
     isActive: true,
     tooltip:"Knowledge Base",
     types:["normal","library_project"],
     roles:['admin','editor','viewer', 'support'],
     subMenuItems:[{'label':" Knowledge Graph" ,"url":"./knowledge/graph", heading: "Knowledge Base", styleClass: 'iconB-cira-1',},
     {'label':" Feature Library" ,isActive: false, "url":"./knowledge/feature-library", styleClass: 'iconB-feature',},
    //  {'label':" Document Library" ,isActive: false, "url":"./knowledge/document-library", styleClass: 'iconB-file-text',},
     {'label':" Small Talk" ,isActive: false,"url":"./knowledge/smalltalk", styleClass: 'iconB-rect-chat-bubble',},
     {'label':" Community Answers" ,isActive: false,"badge" : "count" , "url":"./knowledge/community-answers", styleClass: 'iconB-user-group',},
     {'label':" Instructor Dashboard" ,isActive: false, "badge": "assigned_count",  "url":"./instructor-dashboard", roles: ['admin', 'instructor'], styleClass: 'iconB-instructor-new',},
     {'label':" Profile Library" ,isActive: false, "url":"./knowledge/profile-library", styleClass: 'iconB-bot-user',},
     {'label':" KB Document Library", isActive: false, "url": "./knowledge/kb-document-library", styleClass: 'iconB-file-text'}
    ]},
    {label: "flow", isActive: false, url: "./flow", tooltip:"Workflows",roles:['admin','editor','viewer', 'support'],types:["normal","library_project"],tourAnchor: 'flow-menu',subMenuItems:null},
    {
      label: "training", 
      isActive: false,  
      tooltip:"Training & Testing",
      roles:['admin','editor','viewer', 'support'],
      types:["normal","library_project"], 
      tourAnchor: 'train-menu',
      subMenuItems:[{'label':" Utterances" ,isActive: false, "url":"./test-train/utterances",heading: "Training & Testing", styleClass: 'iconB-utterance',},
      {'label':" Dictionary" ,isActive: false, "url":"./test-train/dictionary", styleClass: 'iconB-dictionary',},
      {'label':" Topic Synonyms" ,isActive: false,"url":"./test-train/topic-synonyms", styleClass: 'iconB-synonym',},
      {'label':" Test" ,isActive: false, "url":"./test-train/test-case", styleClass: 'iconB-test',},
      {'label':" Re Training" ,isActive: false, "url":"./test-train/re-training", styleClass: 'iconB-retraining',},
      {'label':" Document Abbreviation" ,isActive: false, "url":"./test-train/document-abbreviation", styleClass: 'iconB-dictionary',},
    ]},
    {label: "Settings", isActive: false, url: "./settings",tooltip:"Settings",roles:['admin', 'support'],types:["normal","universal","library_project"],subMenuItems:null, tourAnchor: 'settings-menu'},
    {label: "launch", isActive: false, url: "./launch", tooltip:"Launch",roles:['admin', 'editor', 'support'],types:["normal","library_project"],subMenuItems:null, tourAnchor: 'launch-menu'},
    {label: " iconB-connect", isActive: true, url: "./connect-bot", tooltip:"Universal",roles:['admin', 'editor', 'support'],types:["universal"],subMenuItems:null}
	]
  constructor(private _activatedRoute: ActivatedRoute, private _router: Router,public communityService: CommunityService,
    private _eref: ElementRef, public vaService:VaService, public tourService: TourService) {
    this.vaService.flowChangedEvent.subscribe((data) => {
      
      this.setActive(this.steps[data])
      event.stopPropagation();
    })

    this.vaService.breadCrumbChangeEvent.subscribe((data) => {
      
      let item = this.steps[data]
      this.getCurrentStep();
      item.isActive = true;
      this.showMenu = true;
    })
  }

  ngOnInit() {

  
    // this.vaService.userRoleChanged.subscribe(result=>{
    //   if(result == 'instructor'){
    //    this._router.navigate(['../test-training'])
    //   }
    // });

    this.vaService.subItemClickEvent.subscribe(result =>{
      this.showSubMenu = false;
    })
  }



  showSubMenuitem(item,event){
    event.stopPropagation()
    if(item.subMenuItems){
     this.showSubMenu = !this.showSubMenu;
      var subMenuItems = item.subMenuItems
      setTimeout (() => {
          this.vaService.showSubMenuEvent.emit(subMenuItems)
      }, 100);
}

    else{
      this.setActive(item);
      this.showSubMenu=false;
      this.steps.forEach(menu => {
        if (menu.hasOwnProperty('subMenuItems') && (menu.subMenuItems != null)) {
            menu.subMenuItems.forEach(submenu => {
              submenu.isActive = false;
            })
         }
      })
    }

    //this.setActive(item)
}

  onFocusOutEvent(event: any){
    this.hideSubMenuItem()

 }

 hideSubMenuItem(){
  this.showSubMenu = false;

 }

 onClick(event) {
  if (!this._eref.nativeElement.contains(event.target)) // or some similar check
     this.hideSubMenuItem();
  }



  hasPermission(menuIndex){
 // check permission for current user in the menu

  return this.steps[menuIndex]['roles'].indexOf(this.vaService.activeAgent.role)>=0;

  }
  checkType(menuItem){
 
    
    if(!this.vaService.activeAgent.hasOwnProperty("project_type") || this.vaService.activeAgent.project_type == ""){
      this.vaService.activeAgent.project_type = "normal";
      
    }
    return menuItem['types'].indexOf(this.vaService.activeAgent.project_type)>=0
    
    
  }

  setActive(item) {
    
    // if (this.showSubMenu){
    //   this.showSubMenuitem(item)
    // }

    event.stopPropagation();

    event.preventDefault();

    var url = item.url
    if(url == "./knowledge/graph" && !this.vaService.activeAgent.hasOwnProperty('owl_file')) {

      url = './template-selection'
    }

  	this.getCurrentStep();
  	item.isActive = true;
  	this._router.navigate([url], {relativeTo: this._activatedRoute});
  }

  getCurrentStep() {
    this.steps.forEach(item=>{
    	if(item.isActive == true) {
        item.isActive = false;
      }


    })

  	// for (let step of this.steps) {
  	// 	if(step.isActive == true) {
  	// 		return step;

  	// 	}
  	// }
  }
  onStopPropagation(event){
    event.stopPropagation();
 }

  tourNextStep(step) {
    if(step.anchorId === 'profile-library') {
      this._router.navigate(['./knowledge/profile-library'], { relativeTo: this._activatedRoute });
    }
    else if(step.anchorId === 'small-talks') {
      this._router.navigate(['./knowledge/smalltalk'], { relativeTo: this._activatedRoute });
    }
  }
 


}
